var __knownSymbol = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __await = function(promise, isYieldStar) {
  this[0] = promise;
  this[1] = isYieldStar;
};
var __yieldStar = (value) => {
  var obj = value[__knownSymbol("asyncIterator")], isAwait = false, method, it = {};
  if (obj == null) {
    obj = value[__knownSymbol("iterator")]();
    method = (k) => it[k] = (x) => obj[k](x);
  } else {
    obj = obj.call(value);
    method = (k) => it[k] = (v) => {
      if (isAwait) {
        isAwait = false;
        if (k === "throw") throw v;
        return v;
      }
      isAwait = true;
      return {
        done: false,
        value: new __await(new Promise((resolve) => {
          var x = obj[k](v);
          if (!(x instanceof Object)) __typeError("Object expected");
          resolve(x);
        }), 1)
      };
    };
  }
  return it[__knownSymbol("iterator")] = () => it, method("next"), "throw" in obj ? method("throw") : it.throw = (x) => {
    throw x;
  }, "return" in obj && method("return"), it;
};
import { Node_Type, RichContent } from "./../../../../ricos-schema/legacy/wix/rich_content/v1";
import { getParagraphNode } from "../../draft/toDraft/decorationParsers";
import {
  parseAppEmbed,
  parseAudio,
  parseEmbed,
  parseGiphy,
  parseImage,
  parseLinkPreview,
  parseListNode,
  parseMap,
  parseTextNodes,
  parseVideo
} from "./convertNodes";
function* parseCollapsible(node, delimiter) {
  var _a, _b;
  const collapsibleTextNodes = [];
  for (const child of (_a = node.nodes) != null ? _a : []) {
    const [first, second] = (_b = child.nodes) != null ? _b : [];
    if (!first || !second) {
      continue;
    }
    collapsibleTextNodes.push(
      [yield* __yieldStar(toPlainTextBase(first)), yield* __yieldStar(toPlainTextBase(second))].join(delimiter)
    );
  }
  return collapsibleTextNodes.join(delimiter);
}
function* toPlainTextBase(content, delimiter = "\n", addLinksToText = true) {
  const ricosContent = RichContent.fromJSON(content);
  const { nodes = [] } = ricosContent;
  let plainText = "";
  for (let index = 0; index < nodes.length; index++) {
    const node = nodes[index];
    if (node) {
      if (index > 0) {
        plainText += delimiter;
      }
      switch (node.type) {
        case Node_Type.CODE_BLOCK:
        case Node_Type.PARAGRAPH:
        case Node_Type.HEADING:
          plainText += parseTextNodes(node, addLinksToText);
          break;
        case Node_Type.BLOCKQUOTE:
          plainText += parseTextNodes(getParagraphNode(node), addLinksToText);
          break;
        case Node_Type.ORDERED_LIST:
        case Node_Type.BULLETED_LIST:
          plainText += parseListNode(node, delimiter, addLinksToText);
          break;
        case Node_Type.GIF:
          plainText += yield* __yieldStar(parseGiphy(node));
          break;
        case Node_Type.MAP:
          plainText += parseMap(node);
          break;
        case Node_Type.APP_EMBED:
          plainText += parseAppEmbed(node, delimiter);
          break;
        case Node_Type.LINK_PREVIEW:
          plainText += parseLinkPreview(node);
          break;
        case Node_Type.EMBED:
          plainText += parseEmbed(node);
          break;
        case Node_Type.IMAGE:
          plainText += yield* __yieldStar(parseImage(node, delimiter));
          break;
        case Node_Type.VIDEO:
          plainText += yield* __yieldStar(parseVideo(node, delimiter));
          break;
        case Node_Type.AUDIO:
          plainText += yield* __yieldStar(parseAudio(node, delimiter));
          break;
        case Node_Type.COLLAPSIBLE_LIST:
          plainText += yield* __yieldStar(parseCollapsible(node, delimiter));
          break;
        default:
      }
    }
  }
  return plainText;
}
export {
  toPlainTextBase
};
//# sourceMappingURL=to-plain-text-base.js.map
